const initialState = {
    products: [],
    loadingStatus: 'loading'
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case "PRODUCT_LOADING":
            return {
                ...state,
                loadingStatus: 'loading'
            }
        case "PRODUCT_SUCCESS":
            return {
                ...state,
                loadingStatus: 'success'
            }
        case "PRODUCT_ERROR":
            return {
                ...state,
                loadingStatus: 'error'
            }
        case "ADD_PRODUCT":
            return {
                ...state,
                products: [...state.products, action.payload]
            }
        case "DELETE_PRODUCT":
            return {
                ...state,
                products: state.products.filter((element, value) => element.id !== action.payload)
            }
    }
}


export default reducer